import { apiSlice } from "./apiSlice";
import { ENGLISHQUIZATTEMPT_URL } from "../constants";

export const englishQuizAttemptApiSlice =
  apiSlice.injectEndpoints({
    endpoints: (builder) => ({

      // ==================================================
      // STUDENT
      // ==================================================

      // Start English Quiz
      // POST /api/english-quizattempts/start/:quizId

      startEnglishQuizAttempt: builder.mutation({
        query: (quizId) => ({
          url: `${ENGLISHQUIZATTEMPT_URL}/start/${quizId}`,
          method: "POST",
        }),
      }),

      // Get My English Quiz Attempts
      // GET /api/english-quizattempts/my

      getMyEnglishAttempts: builder.query({
        query: () => ({
          url: `${ENGLISHQUIZATTEMPT_URL}/my`,
          method: "GET",
        }),
      }),

      // Resume English Quiz
      // GET /api/english-quizattempts/:attemptId/resume

      resumeEnglishQuizAttempt: builder.query({
        query: (attemptId) => ({
          url: `${ENGLISHQUIZATTEMPT_URL}/${attemptId}/resume`,
          method: "GET",
        }),
      }),

      // Submit English Quiz
      // PUT /api/english-quizattempts/:attemptId/submit

      submitEnglishQuizAttempt: builder.mutation({
        query: ({ attemptId, answers }) => ({
          url: `${ENGLISHQUIZATTEMPT_URL}/${attemptId}/submit`,
          method: "PUT",
          body: {
            answers,
          },
        }),
      }),

      // Get My English Attempt
      // GET /api/english-quizattempts/:attemptId

      // Get My English Attempt
// GET /api/english-quizattempts/:attemptId

getEnglishAttemptById: builder.query({
  query: (attemptId) => ({
    url: `${ENGLISHQUIZATTEMPT_URL}/${attemptId}`,
    method: "GET",
  }),

  transformResponse: (response) =>
    response.attempt,
}),

      // ==================================================
      // ADMIN
      // ==================================================

      // Get All Attempts For Quiz
      // GET /api/english-quizattempts/quiz/:quizId

      getEnglishQuizAttempts: builder.query({
        query: (quizId) => ({
          url: `${ENGLISHQUIZATTEMPT_URL}/quiz/${quizId}`,
          method: "GET",
        }),
      }),

      // Get Single Attempt Details
      // GET /api/english-quizattempts/admin/:attemptId

      getEnglishQuizAttemptDetailsAdmin:
        builder.query({
          query: (attemptId) => ({
            url: `${ENGLISHQUIZATTEMPT_URL}/admin/${attemptId}`,
            method: "GET",
          }),
        }),
    }),
  });

export const {
  useStartEnglishQuizAttemptMutation,
  useSubmitEnglishQuizAttemptMutation,
  useGetMyEnglishAttemptsQuery,
  useResumeEnglishQuizAttemptQuery,
  useGetEnglishAttemptByIdQuery,
  useGetEnglishQuizAttemptsQuery,
  useGetEnglishQuizAttemptDetailsAdminQuery,
} = englishQuizAttemptApiSlice;